angular
	.module( "ATMGurus" )
	.service( "FilterService", FilterService);

FilterService.$inject = ["$location", "$rootScope", "Api.Store", "$state" ];

function FilterService( $location, $rootScope, Store, $state ) {

	var filters = {
		products: { take: 12, page: 1, orderBy: { "price": "DESC" }, where: {}, search: "", },
		repairs: { take: 12, page: 1, orderBy: { "price": "DESC" }, where: {}, search: "", },
		addresses: { take: 5, page: 1, orderBy: [], where: [], search: "" },
		contacts: { take: 5, page: 1, orderBy: [], where: {}, search: "" },
		myAccount: { take: 12, page: 1, orderBy: {}, where: {}, search: "" },
		invoices: { take: 12, page: 1, orderBy: { "invoice_number": "DESC" }, where: {}, search: "" },
		orders: { take: 12, page: 1, orderBy: { "order_number": "DESC" }, where: {}, search: "" },
		'saved-carts': { take: 12, page: 1, orderBy: { "creation_date": "DESC" }, where: {}, search: "" },
		'account-repairs': { take: 12, page: 1, orderBy: {'order_number': 'DESC'}, where: {}, search: "" },
		'recently-shipped': { take: 12, page: 1, orderBy: {'ship_date': 'DESC'}, where: {}, search: "" },
		'inventory-usage': { take: 12, page: 1, orderBy: {}, where: {}, search: "" },
		'cwi-inventory-aging': { take: 12, page: 1, orderBy: {}, where: {}, search: "" }
	}

	var pristineFilters = _.clone(filters);

	var textSearchInstance = textSearch();

	/**
	*	Clear a filter
	*/
	function clearFilter(filter) {
		if (! filters[filter]) return;
		filters[filter] = _.clone(pristineFilters[filter]);
	}

	/**
	*	Fuzzy Search
	*
	*/
	function textSearch() {

		/**
		*	available search scopes for dropdown directive
		*/
		var scopes = [
			{ key: "products", value: "Store" },
			{ key: "repairs", value: "Store" }
		]

		// default searchScope
		var searchScope = {active: "products"};
		var searchString = {text: $location.search()['search']};

		// link route changes to filter, switch search context
		$rootScope.$on("$stateChangeStart", function(evt, toState) {
			// checks state name: [store.products | store.repairs]
			if (! /store/.test(toState.name)) return;
			searchScope.active = "products"
		})

		// when searchString changes
		$rootScope.$watch( function() { return searchString.text; }, function(nv, ov) {
			if (nv == ov) return
			searchScope.active = "products"
			filters[searchScope.active].search = searchString.text;
			$location.search('search', nv)
		})

		/**
		*
		*	doSearch
		*
		*/   
		function doSearch() {
			switch (searchScope.active) {
				case "products":
					if ($state.current.name === 'store.products') {
						filters.products.where = {}
						filters[searchScope.active].page = 1;
						Store.getProducts(filters.products);
						Store.getPagination(filters.products);
						Store.getCategories(filters.products);
						setToUrl("products")
					} else {
						$state.go('store.products');
					}
					break;
			}
		}

		function clearSearch() {
			delete $location.search()['search'];
			if (searchScope.active === 'products') {
				Store.getProducts(filters.products, true);
			}
		}

		return {
			searchScope: searchScope,
			searchString: searchString,
			scopes: scopes,
			clearSearch: clearSearch,
			doSearch: doSearch
		}
	}

	/**
	*	GetFromUrl
	*
	*	returns a well structured object containing
	*	the filters set in the url
	*/
	function getFromUrl(filterType, url) {

		var urlFilters = url || $location.search(),
			returnObject = {}

		angular.copy(filters[filterType], returnObject);

		angular.forEach(urlFilters, function(value, key) {
						switch(key) {
							case 'sortby':
							case 'sortorder':
								returnObject.orderBy = {};
					returnObject.orderBy[urlFilters['sortby']] = urlFilters["sortorder"];
					break;
							case 'search':
					if (!_.isEmpty(value)) {
						returnObject.where = {};
						returnObject.search = value;
						textSearchInstance.searchString.text = value;
					}
					break;
				case 'take':
				case 'page':
						if ( !_.isEmpty( value )) {
							returnObject[key] = parseInt(value);
						}
				break;
				default:
					returnObject.where[ key ] = value;
			}
		});

		return returnObject;
	}

	/**
	*	SetToUrl
	*	read a filter and updates url accordingly
	*/
	function setToUrl(filterType) {
		var filter = filters[filterType];
			$location.search({});

		angular.forEach(filter, function(value, key) {
			switch (key) {
				case "where":
					angular.forEach( filter.where, function( value, key ) {
						$location.search( key, value );
					})
					break;
				case "orderBy":
					$location.search( "sortby", _.keys( filter.orderBy)[0] )
					$location.search( "sortorder", _.values( filter.orderBy)[0] )
					break;
				case "search":
					if (value !== "") {
						$location.search( "search", value);
						textSearchInstance.searchString.text = value;
					} else {
						textSearchInstance.searchString.text = "";
					}
				default:
					$location.search( key, value )
			}
		})
	}

	/**
	*	Service Object
	*
	*/
	return {
		textSearch: textSearchInstance,
		filters: filters,
		clear: clearFilter,
		getFromUrl: getFromUrl,
		setToUrl: setToUrl,
		get: function( filterName ) {
			if (this.filters.hasOwnProperty(filterName)) {
				return this.filters[filterName];
			} else {
				return this.filters
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/services/FilterService.js